module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av687-4b68db15cd1868ede378d05e33399486.jpg";